import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'

export type DemoSeedPackId =
	| 'website-screenshots'
	| 'travel-agency'
	| 'hotel-industry'

export interface DemoAgentCredential {
	email: string
	password: string
	name: string
	role: 'manager' | 'agent'
}

export interface DemoPackRunStatus {
	seeded: boolean
	pack: DemoSeedPackId | string
	label?: string
	run: {
		_id: string
		status: string
		summary: Record<string, number> | null
		credentials: DemoAgentCredential[]
		createdAt?: string
	} | null
}

export interface DemoPackMeta {
	id: DemoSeedPackId | string
	label: string
	screenshotHints?: string[]
	notes?: string[]
}

export interface DemoDataStatus {
	seeded: boolean
	pack: string
	available?: DemoPackMeta[]
	packs?: Record<string, DemoPackRunStatus>
	run: DemoPackRunStatus['run']
}

export interface DemoDataSetupResult {
	message: string
	pack: string
	runId: string
	summary: Record<string, number>
	credentials: DemoAgentCredential[]
	notes: string[]
}

export const getDemoDataStatus = async (clientId: string) => {
	try {
		const { data } = await axios.get<DemoDataStatus>(
			`management/client/${clientId}/demo-data/status`
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export const setupDemoData = async (
	clientId: string,
	pack: DemoSeedPackId = 'website-screenshots'
) => {
	try {
		const { data } = await axios.post<DemoDataSetupResult>(
			`management/client/${clientId}/demo-data/setup`,
			{ pack },
			{ params: { pack } }
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export const teardownDemoData = async (
	clientId: string,
	pack: DemoSeedPackId = 'website-screenshots'
) => {
	try {
		const { data } = await axios.post(
			`management/client/${clientId}/demo-data/teardown`,
			{ pack },
			{ params: { pack } }
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default {
	getDemoDataStatus,
	setupDemoData,
	teardownDemoData,
}
